<template>
  <div v-title="$route.meta.title">
    <intern-only-access-redirect-card v-if="!isIntern" />
    <template v-else>
      <div class="page-heading">
        <h3>{{$route.meta.title}}</h3>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <layout-panel :collapse="false">
        <template slot="header">搜索</template>
        <el-form :model="search"
                 ref="searchForm"
                 label-width="96px"
                 label-position="right"
                 size="medium"
                 @submit.native.prevent="onSearch()">
          <div class="re-el-form__flex">
            <el-form-item label="工单ID"
                          prop="orderid">
              <el-input placeholder="请输入工单ID"
                        v-model="search.orderid"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="错审工单"
                          prop="is_wrong">
              <el-select v-model="search.is_wrong"
                         placeholder="请选择"
                         clearable>
                <el-option v-for="it in isWrongOptions"
                           :key="it.value"
                           :label="it.label"
                           :value="it.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审核状态"
                          prop="status">
              <el-select v-model="search.status"
                         placeholder="请选择"
                         clearable
                         filterable>
                <el-option v-for="it in statusOptions"
                           :key="it.value"
                           :label="it.label"
                           :value="it.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="锁单状态"
                          prop="is_stashed"
                          v-if="false">
              <el-select v-model="search.is_stashed"
                         placeholder="请选择"
                         clearable>
                <el-option v-for="it in lockOptions"
                           :key="it.value"
                           :label="it.label"
                           :value="it.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       native-type="submit">搜索
            </el-button>
          </el-form-item>
        </el-form>
      </layout-panel>

      <layout-panel>
        <template slot="header">列表</template>
        <template slot="tools">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-refresh"
                     @click="onRefresh()"></el-button>
        </template>

<!--        <div class="margin b15">-->
<!--          <div class="today-total-pill">-->
<!--            今日累计已完成单量：<span class="today-total-pill__num">{{todayAuditedTotal}}</span>-->
<!--          </div>-->
<!--        </div>-->

        <el-table :data="table"
                  stripe
                  highlight-current-row
                  border
                  style="width: 100%">
          <el-table-column prop="orderid"
                           label="工单ID">
            <template slot-scope="scope">
              ORD{{scope.row.orderid}}
            </template>
          </el-table-column>
          <el-table-column prop="title"
                           label="任务标题"
                           min-width="160px">
          </el-table-column>
          <el-table-column prop="type"
                           label="任务类型">
            <template slot-scope="scope">
              {{getTaskTypeLabel(scope.row.type)}}
            </template>
          </el-table-column>
          <el-table-column prop="userid"
                           label="完成人">
          </el-table-column>
          <el-table-column prop="salary"
                           label="赏金">
            <template slot-scope="scope">
              {{formatSalary(scope.row.salary)}}
            </template>
          </el-table-column>
          <el-table-column label="审核结果">
            <template slot-scope="scope">
              {{getAuditResultLabel(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column prop="publishtime"
                           label="任务时间">
          </el-table-column>
          <el-table-column label="城市">
            <template slot-scope="scope">
              {{scope.row.provincename}}{{scope.row.cityname}}{{scope.row.areaname}}
            </template>
          </el-table-column>
          <el-table-column prop="marketname"
                           label="门店名称">
          </el-table-column>
          <el-table-column prop="is_stashed"
                           label="锁单状态">
            <template slot-scope="scope">
              {{getLockLabel(scope.row.is_stashed)}}
            </template>
          </el-table-column>
          <el-table-column prop="is_wrong"
                           label="错单状态">
            <template slot-scope="scope">
              {{getIsWrongLabel(scope.row.is_wrong)}}
            </template>
          </el-table-column>
          <el-table-column prop="wrong_source"
                           label="错审来源">
            <template slot-scope="scope">
              {{getWrongSourceLabel(scope.row.wrong_source)}}
            </template>
          </el-table-column>
          <el-table-column prop="status"
                           label="审核状态">
            <template slot-scope="scope">
              {{getStatusLabel(scope.row.status)}}
            </template>
          </el-table-column>
          <el-table-column prop="reviewedtime"
                           label="审核时间">
          </el-table-column>
          <el-table-column label="操作"
                           width="150px"
                           fixed="right">
            <template slot-scope="scope">
              <el-button v-if="!isAuditTaskTimeoutReleased(scope.row)"
                         type="text"
                         size="mini"
                         @click="onView(scope.row)">查看</el-button>
              <el-button type="text"
                         size="mini"
                         :disabled="parseInt(scope.row.is_stashed) !== 1"
                         @click="onUnlock(scope.row)">解锁</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination">
          <el-pagination background
                         @size-change="handleSizePageChange"
                         @current-change="handleCurrentPageChange"
                         :current-page="pagination.current_page"
                         :page-sizes="[20, 50, 100, 200]"
                         :page-size="pagination.per_page"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pagination.total">
          </el-pagination>
        </div>
      </layout-panel>
    </template>
  </div>
</template>

<script>
import Vuex from 'vuex'
import moment from 'moment'
import table from '@core/mixins/table-v3'
import InternOnlyAccessRedirectCard from '@/components/InternOnlyAccessRedirectCard.vue'

export default {
  mixins: [table],
  components: {
    InternOnlyAccessRedirectCard,
  },
  data () {
    return {
      todayAuditedTotal: 0,
      search: {
        orderid: this.$route.query.order_id || null,
        status: null,
        is_wrong: null,
      },
      searchFieldType: {
        orderid: Number,
        status: Number,
        is_wrong: Number,
      },
      statusOptions: [
        {label: '待审核', value: 1},
        {label: '已审核', value: 2},
        {label: '超时释放', value: 3},
        {label: '失效', value: 4},
      ],
      lockOptions: [
        {label: '否', value: 0},
        {label: '是', value: 1},
      ],
      isWrongOptions: [
        {label: '否', value: 1},
        {label: '是', value: 2},
      ],
      wrongSourceOption: [
        {label: '工单复核', value: 1},
        {label: 'Keyin反馈', value: 2},
        {label: '零工申诉', value: 3},
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
      orderOptions: state => state.order && state.order.options ? state.order.options : {allType: []},
    }),
    isIntern () {
      return parseInt(this.user && this.user.usertype) === 4
    },
  },
  created () {
    if (!this.isIntern) return
    this.loadTodayAuditedTotal()
  },
  methods: {
    getTableData (params) {
      if (!this.isIntern) {
        return Promise.resolve({
          data: {
            data: [],
            current_page: params.current_page || 1,
            per_page: params.per_page || 50,
            total: 0,
          },
        })
      }
      return request.page('queryAuditTask', params)
    },
    onRefresh () {
      return this.getTableData(this.lastSearchParams).then((res) => {
        this.setTableData(res)
        this.loadTodayAuditedTotal()
        return res
      })
    },
    loadTodayAuditedTotal () {
      let start = moment().format('YYYY-MM-DD 00:00:00')
      let end = moment().format('YYYY-MM-DD 23:59:59')
      return request.page('queryAuditTask', {
        status: 2,
        reviewedtime: [start, end],
        current_page: 1,
        per_page: 1,
      }).then(({data}) => {
        this.todayAuditedTotal = data.total || 0
      }).catch(() => {
        // 统计失败时不影响列表
      })
    },
    getStatusLabel (status) {
      let it = this.statusOptions.find(x => parseInt(x.value) === parseInt(status))
      return it ? it.label : (status === null || status === undefined ? '' : String(status))
    },
    getLockLabel (isInAudit) {
      let it = this.lockOptions.find(x => parseInt(x.value) === parseInt(isInAudit))
      return it ? it.label : (isInAudit === null || isInAudit === undefined ? '' : String(isInAudit))
    },
    getIsWrongLabel (isWrong) {
      let it = this.isWrongOptions.find(x => parseInt(x.value) === parseInt(isWrong))
      return it ? it.label : (isWrong === null || isWrong === undefined ? '' : String(isWrong))
    },
    getWrongSourceLabel (wrongSource) {
      let it = this.wrongSourceOption.find(x => parseInt(x.value) === parseInt(wrongSource))
      return it ? it.label : (wrongSource === null || wrongSource === undefined ? '' : String(wrongSource))
    },
    getAuditResultLabel (row) {
      let status = parseInt(row && row.status)
      let isPassed = parseInt(row && row.is_passed)
      // 1、空字符串（is_passed=0 and 状态=未审核）
      if (isPassed === 0 && status === 1) return ''
      // 2、审核通过(is_passed = 1)
      if (isPassed === 1) return '审核通过'
      // 3、审核驳回(is_passed=0 and 状态=已审核)
      if (isPassed === 0 && status === 2) return '审核驳回'
      return ''
    },
    getTaskTypeLabel (type) {
      let allType = (this.orderOptions && this.orderOptions.allType) ? this.orderOptions.allType : []
      let it = allType.find(x => parseInt(x.value) === parseInt(type))
      return it ? it.label : (type === null || type === undefined ? '' : String(type))
    },
    formatSalary (salary) {
      if (salary === null || salary === undefined || salary === '') return ''
      let n = Number(salary)
      if (Number.isNaN(n)) return String(salary)
      return n.toFixed(2)
    },
    /** 审核任务状态：3 = 超时释放（与 order-audit-api AuditTask::STATUS_AUTO_RELEASE 一致） */
    isAuditTaskTimeoutReleased (row) {
      return parseInt(row && row.status, 10) === 3
    },
    onView (row) {
      this.$router.push({
        path: `/order/review/${row.orderid}`,
      })
    },
    onUnlock (row) {
      this.$confirm('确认解除该工单的锁单状态？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // 同步解锁：先解锁主平台，再清除本地锁定状态
        return request.alert('unlockAuditTask', {id: row.id}).then(() => {
          return this.onRefresh()
        })
      }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.today-total-pill {
  display: inline-flex;
  align-items: center;
  padding: 10px 18px;
  border-radius: 999px;
  background: linear-gradient(90deg, #eaf4ff 0%, #dff0ff 100%);
  border: 1px solid #d3e8ff;
  color: #3a7bff;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  box-shadow: 0 6px 18px rgba(58, 123, 255, 0.12);
  letter-spacing: 0.5px;
}

.today-total-pill__num {
  margin-left: 6px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/views/audit-task/pages/AuditTaskTable.vue